import { inject, provide, ref } from 'vue'

import { MEDIUM_DATE } from '@/helpers/dates'
import api from '@/store/api'

const CUSTOMER_RECORD = Symbol('customerRecord')

const NO_RECORD = {
  lifetimeState: ref('idle'),
  lifetime: ref(null)
}

export const CUSTOMER_PAIR_INCLUDES =
  'referral_discount_codes,current_cart_subscription,current_cart_subscription.possible_packages,membership_tier,membership_tier.membership_pass,membership_pass_selection'

export function provideCustomerRecord(record) {
  provide(CUSTOMER_RECORD, record)
}

export function useCustomerRecord() {
  return inject(CUSTOMER_RECORD, NO_RECORD)
}

export function fetchCustomerPair(id) {
  return api.call('GET', `conversation_user_pairs/${id}?included=${CUSTOMER_PAIR_INCLUDES}`)
}

export function contactSinceLabel(pair) {
  const createdAt = pair?.attributes?.created_at
  return createdAt ? MEDIUM_DATE.format(Date.parse(createdAt)) : ''
}
